import { useTranslation } from "react-i18next";
import { useInfiniteQuery, useMutation, useQuery } from "react-query";
import { App } from "antd";
import * as api from "apis";

export function useRecruitmentStages({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["recruitments/stages", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getRecruitmentStages(payload);
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export function useRecruitmentStagesById({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["recruitments/stages/id", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getRecruitmentStageById(payload);
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export const useAddRecruitmentStage = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.addRecruitmentStage(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

export const useEditRecruitmentStage = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.editRecruitmentStage(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

export const useDeleteRecruitmentStage = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((id) => api.deleteRecruitmentStage(id), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

export function useRecruitmentTemplates({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["recruitments/templates", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getRecruitmentTemplates(payload);
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export function useRecruitmentTemplateById({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["recruitments/templates/id", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getRecruitmentTemplateById(payload);
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export const useAddRecruitmentTemplate = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.addRecruitmentTemplate(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

export const useEditRecruitmentTemplate = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.editRecruitmentTemplate(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

export const useDeleteRecruitmentTemplate = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((id) => api.deleteRecruitmentTemplate(id), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

export function useRecruitmentTemplateTags({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["recruitments/templates/tags", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getRecruitmentTemplateTags();
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export const useAddRecruitmentBroadcast = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.addRecruitmentBroadcast(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

export const useRecruitmentStageSuggestion = (
  { payload = {} },
  options = {}
) => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useInfiniteQuery(
    ["recruitmentStageSuggestion", payload],
    async ({ pageParam = 1 }) => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getRecruitmentStages({ page: pageParam, ...payload });
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage) {
          return undefined;
        }
        return lastPage.current_page < lastPage.last_page
          ? lastPage.current_page + 1
          : undefined;
      },
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
};

export const useRecruitmentTemplateSuggestion = (
  { payload = {} },
  options = {}
) => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useInfiniteQuery(
    ["recruitmentTemplateSuggestion", payload],
    async ({ pageParam = 1 }) => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getRecruitmentTemplates({ page: pageParam, ...payload });
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage) {
          return undefined;
        }
        return lastPage.current_page < lastPage.last_page
          ? lastPage.current_page + 1
          : undefined;
      },
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
};
